import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, Input, notification} from 'antd';

import {addTaxGroup} from './actions';
import {getDescriptionFromError} from "../utils/errors";
import {formItemLayout} from "../utils/style";

const FormItem = Form.Item;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class AddTaxGroupForm extends Component {
  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {salonId} = this.props;
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.addTaxGroup({...values, salonId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}} = this.props;
    return (
      <Card title="Add Tax Group">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Name"
          >
            {getFieldDecorator('name', {
              rules: [{
                required: true,
                message: 'Name is required'
              }]
            })(
              <Input />
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={hasErrors(getFieldsError())}
              >
                Add Tax Group
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

AddTaxGroupForm.propTypes = {
  form: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  salonId: PropTypes.string.isRequired,
  addTaxGroup: PropTypes.func.isRequired
};

const AddTaxGroupPage = Form.create()(AddTaxGroupForm);

const mapStateToProps = state => ({
  salonId: state.salon.selectedSalonId
});

const mapDispatchToProps = dispatch => ({
  addTaxGroup: payload => (dispatch(addTaxGroup(payload)))
});

export default connect(mapStateToProps, mapDispatchToProps)(AddTaxGroupPage);



// WEBPACK FOOTER //
// ./src/Tax/AddTaxGroupPage.js